import { render } from "./ZapiClientForm.vue?vue&type=template&id=2cde12c1"
import script from "./ZapiClientForm.vue?vue&type=script&lang=js"
export * from "./ZapiClientForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__